// extracted by mini-css-extract-plugin
export default {"signUpForm":"style_signUpForm__Fz7Mw","LoginHeader":"style_LoginHeader__7XYX7","Title":"style_Title__T90tx","Description":"style_Description__+br3w","Box":"style_Box__5QWxG"};